// extracted by mini-css-extract-plugin
module.exports = {"phoneWrapper":"phone_phoneWrapper__10iEA"};